//ブレイクポイント画像切り替え
var $elem = $('.sp_img');
var sp = '_sp.';
var pc = '_pc.';
var replaceWidth = 767; //ブレイクポイント指定
 
function imageSwitch() {
    var windowWidth = parseInt($(window).width()); //ウィンドウサイズ取得
    $elem.each(function () {
        var $this = $(this);
        if (windowWidth >= replaceWidth) {
            $this.attr('src', $this.attr('src').replace(sp, pc));
        } else {
            $this.attr('src', $this.attr('src').replace(pc, sp));
        }
    });
}
imageSwitch();

// リサイズの実行タイミング設定
var delayStart;
var delayTime = 200;
$(window).on('resize', function () {
clearTimeout(delayStart);
delayStart = setTimeout(function () {
imageSwitch();
}, delayTime);
});

$(window).bind("scroll", function() {
    if ($(this).scrollTop() > 500) { 
      $("#pagetop").addClass('active');
    } else {
      $("#pagetop").removeClass('active');
    }
});

//anchor link
$('a[href^="#"]').on('click', function () {
	smooth(this);
	return false;
});

//pagetop
$('#pagetop').on('click',function () {
	animateoffset(0);
	return false;
});


//smoothScroll
function smooth(target){
	var href = $(target).attr('href');
	var hH = 0;
	var top = $(href).offset().top - hH;
	animateoffset(top);
}
function animateoffset(top){
	$('html,body').animate({scrollTop:top}, 600);
}

//js-scroll
var wH = $(window).height();
var EffectH = wH/6*1;
jQuery(window).on('scroll load', function() {
  var scTop = $(this).scrollTop();
  var scBottom = scTop + $(this).height();
  var effectPos = scBottom - EffectH;
  jQuery('.js-scroll, .js-scroll-delay').each( function() {
    var thisPos = $(this).offset().top;
    if ( thisPos < effectPos ) {
      $.when(
        jQuery(this).addClass("show")
      ).done(function() {
        jQuery(this).delay(250).queue(function(){
            jQuery(this).addClass("done")
        })
      });
    }
  });
});


//navi SP
jQuery(function ($) {
  //bodyのスクロール位置の格納
  var state = false;
  var scrollpos;
  $('#toggle').click(function(){
      if($(this).hasClass('active')){
          $(this).removeClass('active');
          $('.l-header').removeClass('active');
          $('.l-header_navArea').fadeOut(400);
      }else{
          $(this).addClass('active');
          $('.l-header').addClass('active');
          $('.l-header_navArea').fadeIn(400).css({"display":"flex"});
      }
      if(state == false) {
        scrollpos = $(window).scrollTop()
        $('body').addClass('fixed').css({'top': -scrollpos})
        state = true;
      } else {
          $('body').removeClass('fixed').css({'top': 0}),
          window.scrollTo( 0 , scrollpos )
          state = false;
      }
  });
  $('.menu-item > a').click(function() {
      if($('.l-header').hasClass('active')){
          $('.l-header_navArea').fadeOut(400);
          $('.l-header').removeClass('active');
          $('#toggle').removeClass('active');
          if(state == false) {
            scrollpos = $(window).scrollTop()
            $('body').addClass('fixed').css({'top': -scrollpos})
            state = true;
          } else {
              $('body').removeClass('fixed').css({'top': 0}),
              window.scrollTo( 0 , scrollpos )
              state = false;
          }
      }
  });
  $('.nav_close').click(function() {
      if($('.l-header').hasClass('active')){
          $('.l-header_navArea').fadeOut(400);
          $('.l-header').removeClass('active');
          $('#toggle').removeClass('active');
          if(state == false) {
              scrollpos = $(window).scrollTop()
              $('body').addClass('fixed').css({'top': -scrollpos})
              state = true;
          } else {
              $('body').removeClass('fixed').css({'top': 0}),
              window.scrollTo( 0 , scrollpos )
              state = false;
          }
      }
  });
});


var heroSlide = $('.p-indexHero_img_slide');
if(heroSlide.length){
  heroSlide.slick({
    autoplay: 3000,
    speed: 1000,
    fade: true,
    arrows: false,
    dots:false,
    mobileFirst: false,
    pauseOnFocus: false,
    pauseOnHover: false,
    pauseOnDotsHover: false,
    draggable: false,
    swipe: false,
  });
}
